import { AppDatePicker } from '@/layout/AppComponents';
import Translator from '../../../../components/helpers/Translator';

const Report1Options = (props) => {
  const { handleOnSetFieldValue, handleOnSubmit, values } = props;

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator
                file="module-lawFinder"
                name="module.lf.filter.from"
              />
            }
            value={values.from}
            onChange={(opt) => handleOnSetFieldValue('from', opt)}
            placeholder="dd/mm/yyyy"
            isClearable
            showMonthDropdown
            showYearDropdown
          />
        </div>
        <div className="col-lg-6">
          <AppDatePicker
            title={
              <Translator file="module-lawFinder" name="module.lf.filter.to" />
            }
            value={values.to}
            onChange={(opt) => handleOnSetFieldValue('to', opt)}
            placeholder="dd/mm/yyyy"
            isClearable
            showMonthDropdown
            showYearDropdown
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          {!values.from ||
          values.from.length === 0 ||
          !values.to ||
          values.to.length === 0 ? (
            <span className="btn btn-info btn-block disabled">
              <Translator
                file="module-intelligence"
                name="module.int.btn.generate"
              />
            </span>
          ) : (
            <span
              className="btn btn-info btn-block"
              onClick={() => handleOnSubmit()}
            >
              <Translator
                file="module-intelligence"
                name="module.int.btn.generate"
              />
            </span>
          )}
        </div>
      </div>
    </>
  );
};

export default Report1Options;
